// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_3Pz9pJI3Ylmwt94dRbh-YD"};